import { render, staticRenderFns } from "./pelletheizung-vorteile-nachteile.vue?vue&type=template&id=309d2ccd"
import script from "./pelletheizung-vorteile-nachteile.vue?vue&type=script&lang=ts"
export * from "./pelletheizung-vorteile-nachteile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports